import { FC } from 'react';

import { useNavigate } from "react-router-dom";
import { Dialog } from 'primereact/dialog';

import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';


interface TDraft83bFilledModalProps {
    message?: string;
    onClose: () => void;
    isCutOff?: boolean;
    filingCreationEnabled: boolean;
}

const Draft83bFilledModal: FC<TDraft83bFilledModalProps> = ({ onClose, filingCreationEnabled, message, isCutOff=false }) => {
    const navigate = useNavigate();
    const goToDashboard = () => {
        navigate('/admin-dashboard');
    }
    const goToNewFiling = () => {
        navigate('/filing/file-83b');
        onClose();
    }
    return (
        <Dialog visible
            closable={false}
            onHide={onClose}
            style={{ width: "25vw" }}
            header={
                <div className="w-full h-full flex flex-column justify-content-center align-items-center mt-1">
                    <div className="border-circle p-4 bg-gray-100 flex-grow-1">
                        <i className={classNames("pi text-4xl", {
                            "pi-verified text-green-500": isCutOff,
                            "pi-exclamation-circle text-red-500": !isCutOff,
                        })}/>
                    </div>
                </div>
            }>
            <div className="text-xl text-color font-semibold text-center -mt-1">
                {message}
            </div>
            <div className='list-none flex flex-column gap-3 align-items-center mt-5'>
                <Button label="Redirect to the dashboard" onClick={goToDashboard} />
                {
                    filingCreationEnabled ? (
                        <Button label="Create a new form" onClick={goToNewFiling} outlined />
                    ) : null
                }
            </div>
        </Dialog>
    )
}

export default Draft83bFilledModal;
